import React from 'react'
import { Link } from 'react-router-dom'
import type { ExampleDefinition } from './types'
import { getCategoryBySlug } from './registry'

interface ExampleCardProps {
  example: ExampleDefinition
}

export function ExampleCard({ example }: ExampleCardProps) {
  const category = getCategoryBySlug(example.category)
  const Component = example.component

  return (
    <Link
      to={`/motion-playground/edit/${example.id}`}
      className="block bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow group"
    >
      <div className="h-44 bg-gray-50 border-b border-gray-100 overflow-hidden relative">
        <Component />
        {example.trigger !== 'auto' && (
          <div className="absolute bottom-2 right-2 text-[9px] text-gray-400 bg-white/80 px-1.5 py-0.5 rounded">
            {example.trigger}
          </div>
        )}
      </div>
      <div className="p-3">
        <div className="flex items-center gap-2 mb-1">
          {category && (
            <span className={`${category.color} text-white text-[9px] font-medium px-1.5 py-0.5 rounded-full`}>
              {category.label}
            </span>
          )}
        </div>
        <h3 className="text-sm font-semibold text-gray-900 mb-0.5">{example.title}</h3>
        <p className="text-xs text-gray-500 leading-relaxed mb-2">{example.description}</p>
        <span className="text-[11px] font-medium text-indigo-600 group-hover:text-indigo-800 transition-colors">
          Edit in Playground &rarr;
        </span>
      </div>
    </Link>
  )
}
